(function () {
	var STATE_KEY = "mhCartToggleState";
	var FORCE_KEY = "mhCartToggleForce";

	function rememberCart(cart) {
		window.__mhLastCart = cart;
		window.__mhCartKnown = true;
		var queued = String(window.__mhPdpQueuedId || "");
		if (!queued || !cart || !cart.items) return;
		for (var i = 0; i < cart.items.length; i++) {
			if (String(cart.items[i].variant_id || cart.items[i].id) === queued) {
				window.__mhPdpQueued = false;
				window.__mhPdpQueuedId = "";
				return;
			}
		}
	}

	var cartReady = fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" })
		.then(function (res) { return res.json(); })
		.then(rememberCart)
		.catch(function () { window.__mhCartKnown = true; });

	function pdpAddonMarker() {
		var node = document.querySelector("[data-mh-pdp-variants]");
		if (!node) return null;
		var addonId = String(node.getAttribute("data-mh-pdp-addon") || "");
		if (!/^\d+$/.test(addonId)) return null;
		var variants = {};
		String(node.getAttribute("data-mh-pdp-variants") || "").split(",").forEach(function (id) {
			if (/^\d+$/.test(id)) variants[id] = true;
		});
		if (!Object.keys(variants).length) return null;
		return { addonId: addonId, variants: variants };
	}

	function variantPresent(variantId) {
		var id = String(variantId);
		if (window.__mhPdpQueued && String(window.__mhPdpQueuedId) === id) return true;
		var cart = window.__mhLastCart;
		if (!cart || !cart.items) return false;
		for (var i = 0; i < cart.items.length; i++) {
			if (String(cart.items[i].variant_id || cart.items[i].id) === id) return true;
		}
		return false;
	}

	function itemsFromJson(data) {
		if (!data || typeof data !== "object") return [];
		var source = Array.isArray(data.items) && data.items.length ? data.items : null;
		if (!source && data.id) source = [data];
		if (!source) return [];
		return source.map(function (item) {
			return {
				id: String(item.id || item.variant_id || ""),
				quantity: parseInt(item.quantity, 10) || 1,
				properties: item.properties && typeof item.properties === "object" ? item.properties : null,
				selling_plan: item.selling_plan || null
			};
		}).filter(function (item) { return /^\d+$/.test(item.id); });
	}

	function itemsFromQuery(query) {
		var params;
		try { params = new URLSearchParams(query); } catch (e) { return []; }
		var grouped = {};
		var hasItems = false;
		params.forEach(function (value, key) {
			var match = key.match(/^items\[(\d+)\]\[id\]$/);
			if (!match) return;
			hasItems = true;
			grouped[match[1]] = { id: value, quantity: 1, properties: null, selling_plan: null };
		});
		if (hasItems) {
			return Object.keys(grouped).sort(function (a, b) { return Number(a) - Number(b); }).map(function (index) {
				var item = grouped[index];
				var qty = params.get("items[" + index + "][quantity]");
				if (qty) item.quantity = parseInt(qty, 10) || 1;
				var plan = params.get("items[" + index + "][selling_plan]");
				if (plan) item.selling_plan = plan;
				params.forEach(function (value, key) {
					var prop = key.match(new RegExp("^items\\[" + index + "\\]\\[properties\\]\\[(.+)\\]$"));
					if (!prop) return;
					item.properties = item.properties || {};
					item.properties[prop[1]] = value;
				});
				return item;
			}).filter(function (item) { return /^\d+$/.test(String(item.id)); });
		}
		var id = params.get("id");
		if (!/^\d+$/.test(String(id || ""))) return [];
		var properties = null;
		params.forEach(function (value, key) {
			var match = key.match(/^properties\[(.+)\]$/);
			if (!match) return;
			properties = properties || {};
			properties[match[1]] = value;
		});
		return [{
			id: String(id),
			quantity: parseInt(params.get("quantity"), 10) || 1,
			properties: properties,
			selling_plan: params.get("selling_plan") || null
		}];
	}

	function leftoverQuery(query) {
		var params = new URLSearchParams(query);
		var parts = [];
		params.forEach(function (value, key) {
			if (key === "id" || key === "quantity" || key === "selling_plan") return;
			if (key.indexOf("properties[") === 0 || key.indexOf("items[") === 0) return;
			parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
		});
		return parts;
	}

	function jsonExtras(data) {
		var extras = {};
		if (!data || typeof data !== "object" || Array.isArray(data)) return extras;
		Object.keys(data).forEach(function (key) {
			if (key === "id" || key === "quantity" || key === "properties" || key === "selling_plan" || key === "items") return;
			extras[key] = data[key];
		});
		return extras;
	}

	function parseAddPayload(body) {
		if (body == null) return null;
		if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
			var asQuery = body.toString();
			return { kind: "form", items: itemsFromQuery(asQuery), extra: leftoverQuery(asQuery) };
		}
		if (typeof FormData !== "undefined" && body instanceof FormData) {
			var hasFile = false;
			var query = new URLSearchParams();
			body.forEach(function (value, key) {
				if (typeof File !== "undefined" && value instanceof File && value.name) hasFile = true;
				else if (typeof value === "string") query.append(key, value);
			});
			if (hasFile) return null;
			var queryText = query.toString();
			return { kind: "form", items: itemsFromQuery(queryText), extra: leftoverQuery(queryText) };
		}
		if (typeof body === "string") {
			var trimmed = body.replace(/^\uFEFF/, "").trim();
			if (!trimmed) return null;
			if (trimmed.charAt(0) === "{") {
				try {
					var data = JSON.parse(trimmed);
					return { kind: "json", items: itemsFromJson(data), extra: jsonExtras(data) };
				} catch (e) { return null; }
			}
			return { kind: "form", items: itemsFromQuery(trimmed), extra: leftoverQuery(trimmed) };
		}
		if (typeof body === "object") {
			return { kind: "json", items: itemsFromJson(body), extra: jsonExtras(body) };
		}
		return null;
	}

	function encodeAddPayload(parsed) {
		if (parsed.kind === "json") {
			var payload = parsed.extra || {};
			payload.items = parsed.items.map(function (item) {
				var line = { id: Number(item.id), quantity: item.quantity || 1 };
				if (item.properties) line.properties = item.properties;
				if (item.selling_plan) line.selling_plan = item.selling_plan;
				return line;
			});
			return { body: JSON.stringify(payload), contentType: "application/json" };
		}
		var parts = [];
		parsed.items.forEach(function (item, index) {
			parts.push("items[" + index + "][id]=" + encodeURIComponent(item.id));
			parts.push("items[" + index + "][quantity]=" + encodeURIComponent(item.quantity || 1));
			if (item.selling_plan) parts.push("items[" + index + "][selling_plan]=" + encodeURIComponent(item.selling_plan));
			if (item.properties) {
				Object.keys(item.properties).forEach(function (key) {
					var safeKey = /^[\w .\-+]+$/.test(key) ? key : encodeURIComponent(key);
					parts.push("items[" + index + "][properties][" + safeKey + "]=" + encodeURIComponent(item.properties[key]));
				});
			}
		});
		if (parsed.extra && parsed.extra.length) parts = parts.concat(parsed.extra);
		return { body: parts.join("&"), contentType: "application/x-www-form-urlencoded; charset=UTF-8" };
	}

	function addsCurrentProduct(items, marker) {
		for (var i = 0; i < items.length; i++) {
			if (marker.variants[String(items[i].id)]) return true;
		}
		return false;
	}

	function payloadHasVariant(items, id) {
		id = String(id);
		for (var i = 0; i < items.length; i++) {
			if (String(items[i].id) === id) return true;
		}
		return false;
	}

	function attachPdpAddon(body) {
		if (window.__mhToggleAdding) return null;
		var marker = pdpAddonMarker();
		if (!marker) return null;
		var parsed = parseAddPayload(body);
		if (!parsed || !parsed.items.length) return null;
		if (!addsCurrentProduct(parsed.items, marker)) return null;
		if (payloadHasVariant(parsed.items, marker.addonId)) return null;
		if (variantPresent(marker.addonId)) return null;
		parsed.items.push({
			id: marker.addonId,
			quantity: 1,
			properties: { _mh_pdp_addon: "1" },
			selling_plan: null
		});
		window.__mhPdpQueued = true;
		window.__mhPdpQueuedId = marker.addonId;
		return encodeAddPayload(parsed);
	}

	function noteProductAdd() {
		if (window.__mhToggleAdding) return;
		try { sessionStorage.setItem(FORCE_KEY, "1"); } catch (e) {}
	}

	function rewriteForm(form, marker) {
		var idInput = form.querySelector('[name="id"]');
		if (!idInput) return false;
		var id = String(idInput.value || "");
		if (!marker.variants[id]) return false;
		if (variantPresent(marker.addonId)) return false;
		if (form.querySelector('[name="items[1][id]"]')) return false;
		var qtyInput = form.querySelector('[name="quantity"]');
		var qty = qtyInput && qtyInput.value ? qtyInput.value : "1";
		function hidden(name, value) {
			var input = document.createElement("input");
			input.type = "hidden";
			input.name = name;
			input.value = value;
			form.appendChild(input);
		}
		hidden("items[0][id]", id);
		hidden("items[0][quantity]", qty);
		var plan = form.querySelector('[name="selling_plan"]');
		if (plan && plan.value) hidden("items[0][selling_plan]", plan.value);
		Array.prototype.forEach.call(form.querySelectorAll('[name^="properties["]'), function (field) {
			var match = String(field.name).match(/^properties\[(.+)\]$/);
			if (!match || field.disabled) return;
			hidden("items[0][properties][" + match[1] + "]", field.value);
			field.disabled = true;
		});
		hidden("items[1][id]", marker.addonId);
		hidden("items[1][quantity]", "1");
		hidden("items[1][properties][_mh_pdp_addon]", "1");
		idInput.disabled = true;
		if (qtyInput) qtyInput.disabled = true;
		if (plan) plan.disabled = true;
		form.setAttribute("data-mh-pdp-rewritten", "1");
		window.__mhPdpQueued = true;
		window.__mhPdpQueuedId = marker.addonId;
		noteProductAdd();
		return true;
	}

	document.addEventListener("submit", function (event) {
		var form = event.target;
		if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;
		if (form.getAttribute("data-mh-pdp-rewritten") === "1") return;
		var marker = pdpAddonMarker();
		if (!marker) return;
		var idInput = form.querySelector('[name="id"]');
		if (!idInput || !marker.variants[String(idInput.value || "")]) return;
		if (!window.__mhCartKnown) {
			event.preventDefault();
			event.stopPropagation();
			cartReady.then(function () {
				rewriteForm(form, marker);
				if (typeof form.requestSubmit === "function") form.requestSubmit();
				else form.submit();
			});
			return;
		}
		rewriteForm(form, marker);
	}, true);

	if (window.XMLHttpRequest && !window.XMLHttpRequest.prototype.__mhExtrasOpen) {
		var xhrOpen = XMLHttpRequest.prototype.open;
		var xhrSend = XMLHttpRequest.prototype.send;
		XMLHttpRequest.prototype.open = function (method, url) {
			this.__mhExtrasUrl = url ? String(url) : "";
			return xhrOpen.apply(this, arguments);
		};
		XMLHttpRequest.prototype.send = function (body) {
			var originalBody = body;
			if (this.__mhExtrasUrl && this.__mhExtrasUrl.indexOf("/cart/add") !== -1) {
				var rewritten = null;
				try { rewritten = attachPdpAddon(body); } catch (e) { rewritten = null; }
				if (rewritten) {
					body = rewritten.body;
					if (rewritten.contentType && typeof FormData !== "undefined" && originalBody instanceof FormData) {
						try { this.setRequestHeader("Content-Type", rewritten.contentType); } catch (err) {}
					}
				}
				this.addEventListener("load", function () {
					if (this.status >= 200 && this.status < 300) noteProductAdd();
				});
			}
			return xhrSend.call(this, body);
		};
		XMLHttpRequest.prototype.__mhExtrasOpen = true;
	}

	if (window.fetch && !window.__mhExtrasFetch) {
		var originalFetch = window.fetch;
		window.fetch = function (resource, init) {
			var url = typeof resource === "string" ? resource : resource && resource.url;
			var fetchInit = init;
			if (url && url.indexOf("/cart/add") !== -1 && init && !window.__mhToggleAdding) {
				var rewritten = null;
				try { rewritten = attachPdpAddon(init.body); } catch (e) { rewritten = null; }
				if (rewritten) {
					var headers = new Headers(init.headers || undefined);
					if (rewritten.contentType) headers.set("Content-Type", rewritten.contentType);
					fetchInit = Object.assign({}, init, { body: rewritten.body, headers: headers });
				}
			}
			return originalFetch.call(this, resource, fetchInit).then(function (response) {
				if (url && url.indexOf("/cart/add") !== -1 && response.ok) noteProductAdd();
				return response;
			});
		};
		window.__mhExtrasFetch = true;
	}

	function toggleRow() {
		return document.querySelector("[data-mh-cart-toggle]");
	}

	function readStates() {
		try { return JSON.parse(sessionStorage.getItem(STATE_KEY) || "{}"); } catch (e) { return {}; }
	}

	function writeStates(states) {
		try { sessionStorage.setItem(STATE_KEY, JSON.stringify(states)); } catch (e) {}
	}

	function setState(productId, state) {
		var states = readStates();
		if (state) states[productId] = state;
		else delete states[productId];
		writeStates(states);
	}

	function lineIsToggle(item, productId) {
		if (String(item.product_id) !== String(productId)) return false;
		var props = item.properties || {};
		if (props._mh_pdp_addon) return false;
		return true;
	}

	function otherLines(cart, productId) {
		return (cart.items || []).filter(function (item) { return !lineIsToggle(item, productId); });
	}

	function toggleLine(cart, productId) {
		var match = null;
		(cart.items || []).forEach(function (item) {
			if (!lineIsToggle(item, productId)) return;
			var props = item.properties || {};
			if (!match || props._mh_cart_toggle) match = item;
		});
		return match;
	}

	function goCheckout() {
		window.location.href = "/checkout";
	}

	function reloadCart() {
		if (window.__mhCheckoutPending) {
			goCheckout();
			return;
		}
		window.location.reload();
	}

	function addToggle(variantId) {
		if (window.__mhToggleAddPromise) return window.__mhToggleAddPromise;
		window.__mhToggleAdding = true;
		window.__mhToggleAddPromise = fetch("/cart/add.js", {
			method: "POST",
			headers: { "Content-Type": "application/json", Accept: "application/json" },
			body: JSON.stringify({
				id: Number(variantId),
				quantity: 1,
				properties: { _mh_cart_toggle: "1" }
			})
		}).finally(function () {
			window.__mhToggleAdding = false;
		});
		return window.__mhToggleAddPromise;
	}

	function removeToggle(key) {
		return fetch("/cart/change.js", {
			method: "POST",
			headers: { "Content-Type": "application/json", Accept: "application/json" },
			body: JSON.stringify({ id: String(key), quantity: 0 })
		});
	}

	function syncToggle() {
		var row = toggleRow();
		if (!row || row.classList.contains("is-busy")) return;
		var productId = row.getAttribute("data-product-id");
		var variantId = row.getAttribute("data-variant-id");
		cartReady.then(function () {
			return fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" });
		}).then(function (res) { return res.json(); }).then(function (cart) {
			rememberCart(cart);
			if (!cart || !cart.items || !cart.items.length) {
				writeStates({});
				return;
			}
			var line = toggleLine(cart, productId);
			var others = otherLines(cart, productId);
			if (line && !others.length) {
				writeStates({});
				return fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } }).then(reloadCart);
			}
			var force = false;
			try { force = sessionStorage.getItem(FORCE_KEY) === "1"; } catch (e) {}
			if (force) {
				try { sessionStorage.removeItem(FORCE_KEY); } catch (e) {}
				if (readStates()[productId] === "off") setState(productId, "");
			}
			if (line) {
				setState(productId, "on");
				row.classList.add("is-on");
				row.setAttribute("data-in-cart", "true");
				row.setAttribute("data-key", line.key);
				if (window.__mhCheckoutPending) goCheckout();
				return;
			}
			if (!others.length) return;
			if (readStates()[productId] === "off") {
				row.classList.remove("is-on");
				var offSwitch = row.querySelector("[data-mh-cart-toggle-switch]");
				if (offSwitch) offSwitch.setAttribute("aria-checked", "false");
				return;
			}
			row.classList.add("is-busy");
			setState(productId, "on");
			return addToggle(variantId).then(function (res) {
				if (!res.ok) throw new Error("add");
				return reloadCart();
			}).catch(function () {
				row.classList.remove("is-busy");
			});
		}).catch(function () {});
	}

	document.addEventListener("click", function (event) {
		var button = event.target.closest("[data-mh-cart-toggle-switch]");
		if (!button) return;
		var row = button.closest("[data-mh-cart-toggle]");
		if (!row || row.classList.contains("is-busy")) return;
		var productId = row.getAttribute("data-product-id");
		var turningOn = !row.classList.contains("is-on");
		row.classList.add("is-busy");
		row.classList.toggle("is-on", turningOn);
		button.setAttribute("aria-checked", turningOn ? "true" : "false");
		var request;
		if (turningOn) {
			setState(productId, "on");
			request = addToggle(row.getAttribute("data-variant-id"));
		} else {
			setState(productId, "off");
			var key = row.getAttribute("data-key");
			request = key ? removeToggle(key) : Promise.resolve({ ok: true });
		}
		request.then(function (res) {
			if (res && res.ok === false) throw new Error("toggle");
			reloadCart();
		}).catch(function () {
			row.classList.remove("is-busy");
			row.classList.toggle("is-on", !turningOn);
			button.setAttribute("aria-checked", turningOn ? "false" : "true");
		});
	});

	document.addEventListener("click", function (event) {
		var checkout = event.target.closest('button[name="checkout"], input[name="checkout"], .checkout_btn');
		if (!checkout) return;
		var row = toggleRow();
		if (!row || !row.classList.contains("is-on")) return;
		if (row.getAttribute("data-in-cart") === "true" && !row.classList.contains("is-busy")) return;
		event.preventDefault();
		event.stopPropagation();
		window.__mhCheckoutPending = true;
		if (!row.classList.contains("is-busy")) {
			row.classList.add("is-busy");
			addToggle(row.getAttribute("data-variant-id")).then(function (res) {
				if (!res.ok) throw new Error("checkout-add");
				goCheckout();
			}).catch(function () {
				row.classList.remove("is-busy");
				window.__mhCheckoutPending = false;
			});
		}
	}, true);

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", syncToggle);
	} else {
		syncToggle();
	}
})();
